import SearchBlock from './search-block';

export default SearchBlock;
